var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodepen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 21.9771L1.75391 15.3257M11.9996 21.9771L22.2453 15.3257M11.9996 21.9771V15.3262M1.75391 15.3257V8.67429M1.75391 15.3257L11.9996 8.67429M1.75391 8.67429L11.9996 2.02289M1.75391 8.67429L11.9996 15.3262M11.9996 2.02289L22.2453 8.67429M11.9996 2.02289V8.67429M22.2453 8.67429V15.3257M22.2453 8.67429L11.9996 15.3262M22.2453 15.3257L11.9996 8.67429",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodepen);
export default __webpack_public_path__ + "static/media/codepen.f1d728ebce1c223388bc6b4f05759406.svg";
export { ForwardRef as ReactComponent };